"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @desc time(ms) 만큼 click event disable
 */
function default_1(time) {
    function handler(e) {
        e.stopPropagation();
        e.preventDefault();
    }
    document.addEventListener('click', handler, true);
    setTimeout(() => document.removeEventListener('click', handler, true), time);
}
exports.default = default_1;
